import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { OperatorsService } from '../../../shared/services/operators.service';
import { AdminCreateOperatorRequest } from '../../../shared/types/operator.types';
import { OperatorFormComponent } from '../operator-form/operator-form.component';

@Component({
  selector: 'app-operator-create',
  imports: [PageHeaderComponent, OperatorFormComponent],
  templateUrl: './operator-create.component.html',
})
export class OperatorCreateComponent {
  private readonly service = inject(OperatorsService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  readonly submitting = signal(false);
  readonly serverError = signal<string | null>(null);

  onSave(payload: AdminCreateOperatorRequest): void {
    this.submitting.set(true);
    this.serverError.set(null);
    this.service
      .create(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (created) => {
          this.submitting.set(false);
          void this.router.navigate(
            created.id ? ['/operators', created.id] : ['/operators'],
          );
        },
        error: (err: unknown) => {
          this.submitting.set(false);
          this.serverError.set(
            toErrorMessage(err, 'La création a échoué.', {
              409: 'Un opérateur existe déjà pour cet utilisateur.',
              404: 'Utilisateur introuvable côté auth-service.',
            }),
          );
        },
      });
  }

  onCancel(): void {
    void this.router.navigate(['/operators']);
  }
}
